module.exports = __webpack_public_path__ + "static/img/company_news11.6bd6983.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutMe/company_news11.png
// module id = vjC+
// module chunks = 2